import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=59fcb1e1&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=59fcb1e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcb1e1",
  null
  
)

export default component.exports